export const baseInputClasses =
  'w-full paragraph-medium leading-[1.25rem] focus:outline-none focus:placeholder-colors-content-tertiary placeholder-colors-content-disabled bg-[inherit] p-300';
